import {select} from 'redux-saga/effects';
import {selectSearchQueryParams} from '@computerrock/formation-router/sagas';
import {apmContractPartnerContractStatusTypes} from '@ace-de/eua-entity-types';
import sapScreenTabs from '../sapScreenTabs';
import modalIds from '../../modalIds';
import filterSAPMapContractPartnersByLocation from './filterSAPMapContractPartnersByLocation';

const loadSAPContractPartnerRecommendations = function* loadSAPContractPartnerRecommendations({payload}) {
    const {match, location} = payload;
    const {serviceCaseId, serviceAssignmentLineNo} = match.params;
    const {activeTab} = yield* selectSearchQueryParams();
    if (activeTab !== sapScreenTabs.SERVICE_PROVIDER || location.query.modal || (location.state?.isModalClosed
        && location.state?.modalId === modalIds.SERVICE_ASSIGNMENT_QM_NOTES)) return;
    const {serviceAssignments} = yield select(state => state.serviceAssignments);
    const serviceAssignment = (serviceAssignments || {})[`${serviceCaseId}-${serviceAssignmentLineNo}`] || null;
    const {contractPartners} = yield select(state => state.contractPartners);
    const contractPartner = (contractPartners || {})[serviceAssignment?.acePartner?.id] || null;
    const currentQueryParams = new URLSearchParams(location.search);
    const isVBASearch = currentQueryParams.get('isVBASearch') === 'false'
        ? false
        : (currentQueryParams.get('isVBASearch') === 'true'
            || contractPartner?.contractStatus === apmContractPartnerContractStatusTypes.FRIENDLY_TOWING_COMPANY
        );

    yield* filterSAPMapContractPartnersByLocation(serviceCaseId, serviceAssignmentLineNo, isVBASearch);
};

export default loadSAPContractPartnerRecommendations;
